export function filterClass(classValue: string | undefined) {
  return classValue && classValue !== "no-class" ? classValue : "";
}

export function joinPath(basePath: string, slug: string) {
  const base = (basePath ?? "").trim();
  const normalizedBase = base.length ? base.replace(/\/+$/, "") : "";
  const normalizedSlug = slug.replace(/^\/+/, "");
  if (!normalizedBase) return `/${normalizedSlug}`;
  return `${normalizedBase}/${normalizedSlug}`;
}
